export default "__VITE_ASSET__BlTKJ8pX__"